/**
 * forEach iterates through the provided object entries, calling the iteratee function
 * for each key-value pair. Similar to Array.prototype.forEach but for objects.
 *
 * @param object the object to iterate over
 * @param iteratee Function called for each entry with parameters (value, key, object)
 */
export const forEach = (object, iteratee) => {
    const objectEntries = Object.entries(object ?? {});
    if (objectEntries.length > 0 && typeof iteratee === "function") {
        for (const [key, value] of objectEntries) {
            iteratee(value, key, object);
        }
    }
};
